module.exports = __webpack_public_path__ + "img/exhibition-1-title@2x.d4e974a8.png";